import axios from 'axios'
import qs from 'qs'
import router from '../router'


var baseHost = (typeof common !== 'undefined' && common.host) ? common.host.replace(/\/+$/, '') : '';
axios.defaults.baseURL = baseHost + '/api';
axios.defaults.imgURL = baseHost;

// 请求拦截器
axios.interceptors.request.use(config => {
    const token = localStorage.getItem('X-Token')
    if (token) {
        config.headers['X-Token'] = token
    }
    config.data = qs.stringify(config.data);
    return config
}, error => {
    return Promise.reject(error)
})


// 响应拦截器：僅在「曾有登入過」（有 token）但狀態失效時才導向登入頁，避免一打開網站就跳登入
axios.interceptors.response.use(res => {
    const msg = res.data && res.data.message;
    const sessionInvalid = msg == '賬號異地登入' || msg == '登入超時' || msg == '用戶未登入';
    if (sessionInvalid) {
        const hadToken = !!localStorage.getItem('X-Token');
        localStorage.removeItem('X-Token');
        if (hadToken) {
            router.push({ name: 'Login' });
        }
    }
    return res
}, error => {
    return Promise.reject(error)
})




export default axios


// WEBPACK FOOTER //
// ./src/axios/index.js